export default __webpack_public_path__ + "static/media/d51.51ecc41c.jpg";